import Marquee from "react-fast-marquee";
import { useLang } from "./LanguageContext";

export const MarqueeBanner = () => {
  const { t } = useLang();
  const words = t.marquee.split("•").map((w) => w.trim()).filter(Boolean);

  return (
    <section className="relative z-10 border-y border-white/10 bg-[#0a0a0a] py-6">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-2xl md:text-4xl tracking-tight text-white/90 mx-8">
              {w}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#ccff00]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
